import {
  Loading,
  ShowContextProvider,
  useShowController,
  // ReferenceField,
  // TextField,
  useTranslate,
  useLocaleState,
} from 'react-admin'
import { BlogAuthor } from '../../components/domains/blogs/BlogAuthor'
import { BlogTitle } from '../../components/domains/blogs/BlogTitle'
import { BlogImgHeader } from '../../components/domains/blogs/BlogImgHeader'
import { BlogContent } from '../../components/domains/blogs/BlogContent'
// import BlogAttachment from '../../components/domains/blogs/BlogAttachment'
import BlogImages from '../../components/domains/blogs/BlogImages'
import {
  Card,
  Container,
  Stack,
  styled,
  // Table,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableHead,
  // TableRow,
  Box,
  Typography,
  TypographyProps,
  Paper,
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import ModifyTimeStamp from '../../components/ModifyTimeStamp'
import { ListActions } from '../../components/list-actions'
import { BLOGS_FIELDS } from '../../providers/localization/constant'
import { ImageField } from '../../components/fields'

const StackStyled = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(4, 5),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 10),
  },
}))

const Heading: React.FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography variant='subtitle2' sx={{ color: '#ADB3BD', fontWeight: 'normal' }} {...props}>
      {children}
    </Typography>
  )
}

const PreviewThumbnail = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: '100%',
    height: 300,
    objectFit: 'cover',
    objectPosition: '50% 50%',
    borderRadius: 5,
  },
}))

const PaperStyled = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 300,
  width: '100%',
  lineHeight: '60px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& .RaImageField-image': {
    verticalAlign: 'middle',
  },
}))

const ContentWrapper = styled(Box)(() => ({ display: 'block', mb: 3 }))

export const BlogShow: React.FC = () => {
  const [locale] = useLocaleState()
  const langActive = locale
  const showController = useShowController()
  const { isLoading, record } = showController
  const translate = useTranslate()
  if (isLoading) return <Loading />

  return (
    <ShowContextProvider value={showController}>
      <Container maxWidth='md'>
        <ListActions
          hasCreate={false}
          hasExport={false}
          hasList={true}
          hasPreview={true}
          hasEdit={true}
        />
        <Card>
          <BlogImgHeader source='cover.full_path' />
          <StackStyled spacing={1}>
            <ModifyTimeStamp />
            <BlogTitle source={`title_${langActive}`} />
            <Stack direction='row' alignItems='center' spacing={0.5}>
              <BlogAuthor authorSource='create_by' dateSource='create_at' />
              {record.all_views ? (
                <>
                  <VisibilityIcon color='disabled' sx={{ fontSize: 18 }} />
                  <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                    {record.all_views}
                  </Typography>
                </>
              ) : null}
            </Stack>
            <ContentWrapper>
              <Heading>
                {translate(`${BLOGS_FIELDS}.short_description`)}
                <BlogContent source={`short_description_${langActive}`} />
              </Heading>
            </ContentWrapper>
            <ContentWrapper>
              <Heading>
                {translate(`${BLOGS_FIELDS}.description`)}
                <BlogContent source={`description_${langActive}`} />
              </Heading>
            </ContentWrapper>
            <ContentWrapper>
              <Heading>
                {translate(`${BLOGS_FIELDS}.thumbnail_path`)}
              </Heading>
              {record.thumbnail ? (
                    <PreviewThumbnail source='thumbnail.full_path' />
                  ) : (
                    <PaperStyled variant='outlined'>
                      <Typography variant='caption' sx={{ color: 'error.main' }}>
                        {translate(`${BLOGS_FIELDS}.thumbnail.notfound`)}
                      </Typography>
                    </PaperStyled>
                  )}
            </ContentWrapper>
            <ContentWrapper>
            <BlogImages source='images' title='name' />
            </ContentWrapper>
            {/* <BlogAttachment source='files.full_path' title='name' /> */}
          </StackStyled>
        </Card>
        {/* <br />
          {record.views && record.views.length !== 0 ? (
            <TableContainer component={Card}>
              <Table sx={{ minWidth: 650 }} aria-label='views table'>
                <TableHead>
                  <TableRow>
                    <TableCell>{translate('resources.Blog.viewer.from')}</TableCell>
                    <TableCell align='right'>{translate('resources.Blog.viewer.views')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {record.views.map((item, id) =>
                    item.property_id == 'guest' ? (
                      <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component='th' scope='row'>
                          {translate('resources.Blog.viewer.guest')}
                        </TableCell>
                        <TableCell align='right'>{item.views}</TableCell>
                      </TableRow>
                    ) : (
                      <TableRow key={id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component='th' scope='row'>
                          <ReferenceField
                            source={'views[' + id + '].property_id'}
                            reference='properties'
                            link={false}
                          >
                            <>
                              <TextField source='project_code' />-
                              <TextField source={translate('resources.Blog.viewer.project')} />
                            </>
                          </ReferenceField>
                        </TableCell>
                        <TableCell align='right'>{item.views}</TableCell>
                      </TableRow>
                    ),
                  )}
                  <TableRow key='all' sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component='th' scope='row'>
                      <b>{translate('resources.Blog.viewer.all_views')}</b>
                    </TableCell>
                    <TableCell align='right'>{record.all_views ? record.all_views : 0}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null} */}
      </Container>
    </ShowContextProvider>
  )
}

export default BlogShow
